import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import type { AppState } from '~/reducers';
import { NativeCommandEnum } from '../models/commands';
import HybridWebView from '../utils/HybridWebView';
import { mutex } from '~/domain/auth/utils/auth-lock';

const useWebviewAuth = () => {
  const authenticatedError = useSelector((state: AppState) => state.authentication.error);
  const authenticated = useSelector((state: AppState) => state.authentication.authenticated);
  const onWebView = useSelector((state: AppState) => state.native.onWebView);
  const mauiLogout = useCallback(() => {
    // Not using dispatcher here since logout triggered a clear of redux state as well.
    HybridWebView.SendInvokeMessageToDotNet(NativeCommandEnum.NavigateToLogin, undefined);
  }, []);

  useEffect(() => {
    if (authenticatedError?.status === 401 && !authenticated && !mutex.isLocked()) {
      mauiLogout();
    }
  }, [authenticated, authenticatedError?.status, mauiLogout, onWebView]);
  return { mauiLogout };
};
export { useWebviewAuth };
